import React from 'react';
import { formatDistanceToNowStrict, isValid } from 'date-fns';

import { getDisplayStatus } from './webEmbedUtils';

const FALLBACK_VALUE = '--';

const renderDestinationUrl = webEmbed => {
  const destinationUrl = webEmbed.destinationUrl;
  if (!destinationUrl) return FALLBACK_VALUE;

  return (
    <a
      className="web-embed-destination-url"
      href={destinationUrl}
      target="_blank"
      rel="noopener noreferrer"
      title={destinationUrl}
      onClick={event => event.stopPropagation()}
    >
      {destinationUrl}
    </a>
  );
};

const renderStatus = webEmbed => {
  if (!webEmbed.status) return FALLBACK_VALUE;

  const status = getDisplayStatus(webEmbed);
  const statusClass = status === 'Active' ? 'success' : 'warning';
  return <span className={`status badge badge-pill badge-outline-${statusClass}`}>{status}</span>;
};

const renderCreateTime = webEmbed => {
  if (!webEmbed.createTime) return FALLBACK_VALUE;

  const createTime = new Date(webEmbed.createTime);
  if (!isValid(createTime)) return FALLBACK_VALUE;

  return <div className="ellipsis">{formatDistanceToNowStrict(createTime)} ago</div>;
};

const createWebEmbedColumns = () => [
  {
    Header: 'Display Name',
    id: 'displayName',
    type: 'string',
    accessor: webEmbed => webEmbed.displayName || FALLBACK_VALUE
  },
  {
    Header: 'Destination URL',
    id: 'destinationUrl',
    type: 'string',
    accessor: renderDestinationUrl
  },
  {
    Header: 'Attribution Window Days',
    id: 'attributionWindowDays',
    type: 'number',
    accessor: webEmbed => {
      const value = webEmbed.attributionWindowDays;
      return value === null || typeof value === 'undefined' || value === '' ? FALLBACK_VALUE : value;
    }
  },
  {
    Header: 'Status',
    id: 'status',
    type: 'string',
    accessor: renderStatus
  },
  {
    Header: 'Create Time',
    id: 'createTime',
    type: 'date',
    accessor: renderCreateTime
  }
];

export default createWebEmbedColumns;
